var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin",
    transform: "translate(-1795 -554)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 38,
    height: 48,
    transform: "translate(1792 554)",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "trash-2",
    d: "M16.545,6.455V18.273a.909.909,0,0,1-.909.909H6.545a.909.909,0,0,1-.909-.909V6.455Zm-.909-1.818V3.727A2.728,2.728,0,0,0,12.909,1H9.273A2.728,2.728,0,0,0,6.545,3.727v.909H2.909a.909.909,0,0,0,0,1.818h.909V18.273A2.728,2.728,0,0,0,6.545,21h9.091a2.728,2.728,0,0,0,2.727-2.727V6.455h.909a.909.909,0,0,0,0-1.818Zm-7.273,0V3.727a.909.909,0,0,1,.909-.909h3.636a.909.909,0,0,1,.909.909v.909Zm0,5.455v5.455a.909.909,0,0,0,1.818,0V10.091a.909.909,0,0,0-1.818,0Zm3.636,0v5.455a.909.909,0,0,0,1.818,0V10.091a.909.909,0,1,0-1.818,0Z",
    transform: "translate(1802 568)",
    fill: "#05152d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.456f4606296e2c82ecaea40d0e944853.svg";
export { ForwardRef as ReactComponent };